
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.973 1.028C17.203-.74 13.726-.157 10 2.236 6.274-.156 2.797-.737 1.027 1.028c-1.766 1.766-1.185 5.24 1.21 8.964-2.394 3.724-2.976 7.199-1.21 8.965 2.725 2.723 8.164-.686 8.973-1.205.812.521 6.246 3.926 8.973 1.205 1.766-1.766 1.185-5.24-1.21-8.965 2.394-3.724 2.976-7.198 1.21-8.964zm-1.517 1.515c.748.747.472 2.886-1.059 5.55A27.604 27.604 0 0011.9 3.6c1.88-1.079 4.563-2.046 5.557-1.056zm-14.912 0c.998-.994 3.69-.015 5.557 1.056a27.645 27.645 0 00-4.498 4.494C2.073 5.43 1.796 3.29 2.544 2.543zm0 14.898c-.748-.747-.472-2.886 1.059-5.55a27.213 27.213 0 004.5 4.49c-2.666 1.53-4.808 1.806-5.559 1.06zM10 15.12a23.937 23.937 0 01-5.132-5.127A24.682 24.682 0 0110 4.842c2.636 1.957 4.277 4 5.132 5.15A23.909 23.909 0 0110 15.12zm7.456 2.321c-.752.747-2.893.47-5.56-1.06a27.214 27.214 0 004.501-4.49c1.53 2.664 1.807 4.803 1.059 5.55zM10 8.563a1.43 1.43 0 10-.001 2.86A1.43 1.43 0 0010 8.563z","fill":"#0B0E1F"}})])
          )
        }
      }
    